import type { FaireProductEntity } from "../../entity_types/product";

export const p_pe6ggxsbxn: FaireProductEntity = {
  token: "p_pe6ggxsbxn",
  type: "product",
  name: "Cowboy",
  brandToken: "b_qkjzzyp79p",
  brandName: "Nose Dive",
  imageUrl:
    "https://cdn.faire.com/fastly/ea31c199722b18b672386a0e3a72fbab0938efe64c3c6b0b338dd02f42479781.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/2359c2e85b5d6a34a71e69bd508e693f707d62d45d0df9e21c72263ff42a8e04.jpeg",
    "https://cdn.faire.com/fastly/af800aae8250c9a3f1cabc474bec3ea9aaba7469a0c091bb2a1a8a21c7d05bb7.jpeg",
    "https://cdn.faire.com/fastly/7c2d9d1aba60d6967af9986a18ad2730f4bceb07566ddeee9d632318a1da564f.jpeg",
    "https://cdn.faire.com/fastly/ac886c11bc67869270824711bc73dbec9190f4667f41973e099e502e9516f923.jpeg",
    "https://cdn.faire.com/fastly/0da7ab02abaf951eda578bbfcccd55029f4880cfa775fd322496ad3453947bea.jpeg",
    "https://cdn.faire.com/fastly/2219f7ca4b70596063cb5879242889a00f46febcc5c4f4bdbd98fad4e01711cf.jpeg",
  ],
  priceDollars: 21,
  description:
    'Open fields, crushed leaves, tomato on the vine. Cowboy is raw and nostalgic, a fragrance rooted in the outdoors.\n\nTop Notes: tomato leaf, dewy, citrus, bergamot\n\nMiddle Notes: basil, green & wild herb, floral\n\nBase Notes: moist earth, musk, twig, patchouli\n\nFounder\'s Note: "This candle is quirky and nostalgic. The combo of green tomato + basil is so dreamy and lux. I love burning this candle on the weekends when I am cooking and have the windows open. It transports me to childhood days."\n',
  tags: [],
  msrpDollars: 42,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-09-17T19:49:25.250Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
